export default __webpack_public_path__ + "static/media/mainlogoBlue.374c0b4e.svg";